import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import TablePageContext from "../../../Context/TablePageContext";
import LinearProgress from '@mui/material/LinearProgress';
import PipelineForm from "../../../Components/Forms/Pages/Administration/Pipeline/PipelineForm";
import {addPipeline} from "../../../Services/Company/PipelineService";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: {value: true, message: strings.forms.common.thisFieldIsRequired}},
    'type': {required: {value: true, message: strings.forms.common.thisFieldIsRequired}},
}

const AddPipeline = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const form = useForm();
    const { showMessage } = useContext(SnackbarContext);
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.administration.pipeline.addPipeline.pageTitle);
    });

    const onSubmit = (data) => {

        setShowLoader(true);

        addPipeline(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <PipelineForm
                formRules={formRules}
                values={getValues()}
                control={control}
                setValue={setValue}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddPipeline;